import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Constants } from '../../../constants/constants';
import { environment } from '../../../../environments/environment';
import { EmpresaService } from '../services/empresa.service';
import { ParametrosRespuestaDto } from '../../../dto/auth/autenticacion-digital.dto';
import { ModalRestablecerContraseniaComponent } from '../modal-restablecer-contrasenia/modal-restablecer-contrasenia.component';
import { LanguageService } from '../../../services/util/language.service';

@Component({
  selector: 'app-autenticacion-digital',
  templateUrl: './autenticacion-digital.component.html',
  styleUrl: './autenticacion-digital.component.scss'
})
export class AutenticacionDigitalComponent implements OnInit {
  private crearCuenta: string = Constants.CREAR_CUENTA;
  flag: boolean = false;
  path: string = environment.AUTH_FRONT;

  textoPasosCreacion!: ParametrosRespuestaDto;

  openModalFPassword: boolean = false;
  @ViewChild(ModalRestablecerContraseniaComponent)
  ModalRestablecerContraseniaComponent!: ModalRestablecerContraseniaComponent;

  idiomaActual: string = 'es';
  constructor(
    private router: Router,
    private readonly empresaService: EmpresaService,
    private languageService: LanguageService
  ) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.flag = navigation.extras.state['origen'] === this.crearCuenta;
    }
  }
  ngOnInit(): void {

    this.getTextoPasosRegistro();
    this.idiomaActual = this.languageService.getCurrentLanguage();
    this.languageService.currentLanguage$.subscribe(lang => {
      this.idiomaActual = lang;
    });
  }

  redirectToCarpetaCiudadanaDigital(): void {
    window.open(`${this.path}/auth/sign-in?entidadId=${environment.ID_ENTITY}`, '_blank', 'noopener,noreferrer');
  }

  redirectToFormEmpresa() {
    this.router.navigate(['/registroEmpresa']);
  }

  getTextoPasosRegistro() {
    const body = {
      pagina: 1,
      tamanoPagina: 10,
      ordenarPor: Constants.DESCRIPCION,
      ordenarAsc: true,
      filtros: {
        nombre_parametro: Constants.INSTRUCCIONES_CREACION_EMPRESA
      }
    };
    this.empresaService.parametrizacionPasosEmpresa(body).subscribe((response: any) => {
      this.textoPasosCreacion = response;
    })
  }

  openModalContrasenia() {
    this.openModalFPassword = true;
    setTimeout(() => {
      this.ModalRestablecerContraseniaComponent.abrirCerrarModal();
    }, 100);
  }

}
